import * as Criteria from "./Criteria/index.js";
import { UserPortal } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsSearch.Apartments.UserPortal */
export { UserPortal };
import { ListingPhoneType } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsSearch.Apartments.ListingPhoneType */
export { ListingPhoneType };
/** CoStar.Api.AptsSearch.Apartments.ClusterCenteringMode */
export var ClusterCenteringMode;
(function (ClusterCenteringMode) {
    ClusterCenteringMode[ClusterCenteringMode["Default"] = 0] = "Default";
    ClusterCenteringMode[ClusterCenteringMode["Average"] = 1] = "Average";
    ClusterCenteringMode[ClusterCenteringMode["First"] = 2] = "First";
    ClusterCenteringMode[ClusterCenteringMode["Last"] = 3] = "Last";
    ClusterCenteringMode[ClusterCenteringMode["BoundsCenter"] = 4] = "BoundsCenter";
})(ClusterCenteringMode || (ClusterCenteringMode = {}));
import { CountTypes } from "../../../../CoStar/Api/AptsSearch/ViewModels/index.js";
/** CoStar.Api.AptsSearch.Apartments.CountTypes */
export { CountTypes };
/** CoStar.Api.AptsSearch.Apartments.GeoLookupMatchType */
export var GeoLookupMatchType;
(function (GeoLookupMatchType) {
    GeoLookupMatchType[GeoLookupMatchType["Unknown"] = 0] = "Unknown";
    GeoLookupMatchType[GeoLookupMatchType["Property"] = 1] = "Property";
    GeoLookupMatchType[GeoLookupMatchType["PostalCode"] = 2] = "PostalCode";
    GeoLookupMatchType[GeoLookupMatchType["City"] = 3] = "City";
    GeoLookupMatchType[GeoLookupMatchType["BuildingName"] = 4] = "BuildingName";
    GeoLookupMatchType[GeoLookupMatchType["Submarket"] = 5] = "Submarket";
    GeoLookupMatchType[GeoLookupMatchType["Street"] = 6] = "Street";
    GeoLookupMatchType[GeoLookupMatchType["ResearchMarket"] = 7] = "ResearchMarket";
    GeoLookupMatchType[GeoLookupMatchType["Contact"] = 8] = "Contact";
    GeoLookupMatchType[GeoLookupMatchType["Company"] = 9] = "Company";
    GeoLookupMatchType[GeoLookupMatchType["County"] = 10] = "County";
    GeoLookupMatchType[GeoLookupMatchType["Subdivision"] = 11] = "Subdivision";
    GeoLookupMatchType[GeoLookupMatchType["GeocodeResult"] = 12] = "GeocodeResult";
    GeoLookupMatchType[GeoLookupMatchType["BuildingPark"] = 13] = "BuildingPark";
    GeoLookupMatchType[GeoLookupMatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeoLookupMatchType[GeoLookupMatchType["Country"] = 15] = "Country";
    GeoLookupMatchType[GeoLookupMatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeoLookupMatchType[GeoLookupMatchType["Region"] = 17] = "Region";
    GeoLookupMatchType[GeoLookupMatchType["StoreType"] = 18] = "StoreType";
    GeoLookupMatchType[GeoLookupMatchType["TransitStation"] = 19] = "TransitStation";
    GeoLookupMatchType[GeoLookupMatchType["PropertyResidential"] = 20] = "PropertyResidential";
    GeoLookupMatchType[GeoLookupMatchType["Airport"] = 22] = "Airport";
    GeoLookupMatchType[GeoLookupMatchType["HotelName"] = 23] = "HotelName";
    GeoLookupMatchType[GeoLookupMatchType["Military"] = 25] = "Military";
    GeoLookupMatchType[GeoLookupMatchType["University"] = 26] = "University";
})(GeoLookupMatchType || (GeoLookupMatchType = {}));
export { Criteria };
